<mat-icon *ngIf="machine.remoteMachine" svgIcon="disconnected"></mat-icon>
<span>{{ machine.name }}</span>
